import React from 'react';

import Typography from 'components/uiLibrary/Typography';

import EntityName from 'components/Globals/EntityName';
import RedMaskIcon from 'components/Productions/Display/RedMaskIcon';

import { TP } from 'constants/index';

import { useTranslation } from 'src/i18n';

import classes from './EntityRoles.module.scss';

const EntityRoles = ({ entityRoles, entity, entityType, data, trackingData }) => {
  const { t } = useTranslation('NS_APP_GLOBALS');

  if (!entityRoles?.length) {
    return null;
  }

  const [primaryRole, ...otherRoles] = entityRoles || [];
  const roles = `${t(primaryRole)}${
    otherRoles.length > 0 ? ` ${t(`${TP}.FN_ROLES_WITH_COUNT`, { count: otherRoles.length })}` : ''
  }`;

  const isCover = data?.contributions?.find(act => act?.profile?.id === entity?.id)?.isCover;

  return (
    <div className={classes.entityRoles}>
      {roles && (
        <Typography variant="p" size={12} truncate>
          <RedMaskIcon entity={entity} entityType={entityType} data={data} size={12} />
          <Typography variant="span" color="secondary" italic size={12} className={classes.entityRoles__roles}>
            {roles}
          </Typography>
          <EntityName entity={entity} entityType={entityType} isRaw trackingData={trackingData} />
          {isCover && (
            <Typography color="secondary" italic size={12}>
              ({t(`${TP}.FN_COVER`)})
            </Typography>
          )}
        </Typography>
      )}
    </div>
  );
};

export default EntityRoles;
